



























































































































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { readUserProfile } from '@/store/main/getters';
import { IUserProfile } from '@/interfaces';
import {ProcessStateEnum} from '@/interfaces';
import { IDRec } from '@/interfaces';
import {commitAddNotification} from '@/store/main/mutations';

interface UpdatePreparationsRec {
  preparationtype_id: number|null;
  confirmed: boolean|null;
  comments: string|null;
}
interface NewInspectionsRec {
  count: number;
  planned_date: string|null;
  due_date: string|null;
  remarks: string|null;
  inspector1_id: number|null;
  inspector2_id: number|null;
  inspector3_id: number|null;
  responsible_id: number|null;
}

@Component
export default class InspectionsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public showNextActions = false;
  public groupActions = [];
  public recAction: any = {};
  public dialogAction = false;
  public showUpdatePreparations = false;
  public showAction2 = false;
  public dialogUpdatePreparations = false;
  public showNewInspections = false;
  public dialogNewInspections = false;
  public dialogReadyForSigning = false;
  public listReadyForSigning = [];
  public filterJobList = false;

  public recUpdatePreparations: UpdatePreparationsRec = {preparationtype_id: null, confirmed: null, comments: null};
  public recNewInspections: NewInspectionsRec = {count: 1, planned_date: null, due_date: null, remarks: null, inspector1_id: null, inspector2_id: null, inspector3_id: null, responsible_id: null};


  public handleTableLoaded(overview) {
    // console.log(check_bool(overview.filters.not_sent_accounting) , (overview.filters.customer_id > 0) , (overview.tableTotal > 0));
  }
  public async handleItemSelected(overview, event) {
    // console.log('handleItemSelected', event);
    if (event.value) {
      const ids = overview.selected.map(el => el);
      ids.push(event.item);
      await this.changeSelection(overview, ids);
    } else {
      const ids = overview.selected.filter(el => el.id !== event.item.id).map(el => el);
      await this.changeSelection(overview, ids);
    }
  }
  public async handleToggleSelectAll(overview, event) {
    // console.log('handleToggleSelectAll', event);
    if (event.value) {
      const ids = event.items.map(el => el);
      await this.changeSelection(overview, ids);
    } else {
      const ids = [];
      await this.changeSelection(overview, ids);
    }
  }
  public async handleChangeMultiSelect(overview, event) {
    // console.log('handleChangeMultiSelect', event);
    if (event.value) {
      const ids = overview.selected.map(el => el);
      await this.changeSelection(overview, ids);
    } else {
      const ids = [];
      await this.changeSelection(overview, ids);
    }
  }
  public async changeSelection(overview, selected) {
    // console.log('changeSelection', selected);
    if (selected.length > 0) {
      this.showUpdatePreparations = this.showAction2 = true;
      const allSameState = selected.every(el => el.processstate_name_nl === selected[0].processstate_name_nl);
      // console.log(selected.length, allSameState)
      if (allSameState) {
        const rec = {idlist: selected.map(el => el.id)};
        const response = await this.api.postAction(this.$store, this.apiUrl + 'check_next_actions', rec);
        if (response) {
          const data = response.data as any;
          // console.log('check_next_actions', data);
          this.groupActions = data;
          this.showNextActions = this.groupActions.length > 0;
        }
      } else {
        this.showNextActions = false;
      }
    } else {
      this.showUpdatePreparations = this.showAction2 = this.showNextActions = false;
    }
  }
  public async execGroupAction(action) {
    const overview: any = this.$refs.overview;
    this.recAction.url = this.apiUrl + 'group_action';
    this.recAction.action = action;
    this.recAction.idlist = overview.selected.map(el => el.id);
    if (action.reason === true) {
      this.dialogAction = true;
    } else {
      await this.executeAction();
    }
  }
  public async executeAction() {
    const data = {
      nextprocessstate_id: this.recAction.action.state_id,
      idlist: this.recAction.idlist
    };
    if (this.recAction.action.reason) {
      (data as any).reason = this.recAction.reason;
    }
    const response = await this.api.postAction(this.$store, this.recAction.url, data);
    if (response) {
      // const ref: any = this.$refs.layout;
      const overview: any = this.$refs.overview;
      overview.tableUpdateData(true);
    }
  }
  public startUpdatePreparations() {
    // const overview: any = this.$refs.overview;
    // this.recUpdatePreparations.bank_date = new_curdate();
    this.dialogUpdatePreparations = true;
  }
  public async executeUpdatePreparations(rec) {
    this.dialogUpdatePreparations = false;
    const overview: any = this.$refs.overview;
    rec.idlist = overview.getSelectedIds();
    const response = await this.api.postAction(this.$store, this.apiUrl + 'update_preparation', rec);
    overview.tableUpdateData(true);
  }
  public toggleJobList() {
    const overview: any = this.$refs.overview;
    if (this.filterJobList) {
      overview.setFilterValues({planned_date_ge: null, inspector_id: null, processstate_id: null});
      overview.setSortString('name|D');
    } else {
      const profile: IUserProfile | null = readUserProfile(this.$store);
      if (profile) {
        overview.setFilterValues({planned_date_ge: this.api.today(), inspector_id: profile.id, processstate_id: ProcessStateEnum.ready_for_inspection});
        overview.setSortString('planned_date');
      }
    }
    this.filterJobList = !this.filterJobList;
  }
  public startNewInspections() {
    // const overview: any = this.$refs.overview;
    // this.recNewInspections.bank_date = new_curdate();
    this.dialogNewInspections = true;
  }
  public async executeNewInspections(rec) {
    this.dialogNewInspections = false;
    const overview: any = this.$refs.overview;
    const response = await this.api.postAction(this.$store, this.apiUrl + 'create_inspections', rec);
    overview.tableUpdateData(true);
  }

  public checkInspectors(rec) {
    // console.log('checkInspectors >', rec.inspector1_id, rec.inspector2_id, rec.inspector3_id);
    const i1 = rec.inspector1_id;
    let i2 = rec.inspector2_id;
    let i3 = rec.inspector3_id;
    if (i3 && ((i3 === i2) || (i3 === i1))) {
      i3 = null;
      this.$set(rec, 'inspector3_id', i3);
    }
    if (i2 && i2 === i1) {
      if (i3) {
        i2 = i3;
        i3 = null;
        this.$set(rec, 'inspector2_id', i2);
        this.$set(rec, 'inspector3_id', i3);
      } else {
        i2 = null;
        this.$set(rec, 'inspector2_id', i2);
      }
    }
    // console.log('checkInspectors <>', rec.inspector1_id, rec.inspector2_id, rec.inspector3_id);
  }

  public async showReadyForSigning() {
    const response = await this.api.postAction(this.$store, '/inspections/docusigncountenvelopes');
    if (response && response.data) {
      this.listReadyForSigning = (response.data as any).recs;
      this.dialogReadyForSigning = true;
    }
    // this.dialog = true;
  }
  public async executeReadyForSigning() {
    const response = await this.api.postAction(this.$store, '/inspections/docusignsendenvelopes');
    this.dialogReadyForSigning = false;
  }
  public async checkSignedDocs() {
    const response = await this.api.postAction(this.$store, '/inspections/docusignimportenvelopes');
    if (response && response.data) {
      commitAddNotification(this.$store, {content: (response.data as any).info, color: 'info'});
    }
  }



}
